<template>
  <div class="temp">
    <dv-capsule-chart :config="outPutConfig" class="temp"/>
  </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "MonthOutput",
  mixins: [EmCommonApi],
  data() {
    return {
      outPutConfig: {},
      refresh: null
    };
  },
  mounted() {
    this.getMonthOpPlanningHours();
    this.refresh = setInterval(() => {
      this.getMonthOpPlanningHours();
    }, 24 * 36000 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.refresh);
  },
  methods: {
    getMonthOpPlanningHours() {
      let _this = this;
      const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesPrdPpOperation")}/sithMesPrdPpOperation/kpiHours/history`
      this.$_emApiMixin_get(_api, false).then(value => {
        let list = [];
        for (let item in value) {
          if (value.hasOwnProperty(item)) {
            list.push({
              name: item,
              value: value[item]
            });
          }
        }
        _this.outPutConfig = {
          data: list,
          colors: ["#e062ae", "#fb7293", "#e690d1", "#32c5e9", "#96bfff"],
          unit: "%",
          showValue: true
        }
      })
    }
  }
};
</script>

<style scoped>
.temp {
  width: 100%;
  height: 100%;
}

.temp >>> .label-column {
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.temp >>> .capsule-item {
  height: 0.625rem;
}

.temp >>> .capsule-item .capsule-item-column .capsule-item-value {
  font-size: 0.9rem;
}

.temp >>> .unit-label {
  font-size: 0.9rem;
}

.temp >>> .unit-text {
  font-size: 0.9rem;
}
</style>
